module.exports = __webpack_public_path__ + "static/media/CurriculumSciExamBigIcon.8431a78d.svg";